import { atom } from 'jotai';

export interface ClipboxExportTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  /** Drives the `layerByproducts` lookup that resolves the success toast's
   *  Download action to the actual presigned URL. The new byproduct row's
   *  `sourceAttachmentId` matches the source layer's, so this is the layer
   *  we query against. */
  sourceLayerId: string;
  sourceLayerName: string;
  /** 'LAZ' | 'E57' — only used in toast copy ("Clipped LAZ ready: …"). */
  format: string;
}

export const clipboxExportTrackingAtom = atom<ClipboxExportTracker[]>([]);
